var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document",style:(_vm.document.properties && _vm.document.properties.style
      ? _vm.document.properties.style
      : {})},[(_vm.document.format === 'RICH_TEXT')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.document.content)}}):(_vm.document.format === 'PDF')?_c('div',_vm._l((_vm.pdf.totalPage),function(i){return _c('vue-pdf',{key:i,attrs:{"src":_vm.document.url,"page":i}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-384c8613","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/document/_id.vue
// module id = null
// module chunks = 